'use client'

import React from 'react'
import Image from 'next/image'
import { useTheme } from '@/app/[locale]/ThemeProvider'

interface FooterLogoProps {
  siteName: string
  siteLogo: string
  darkModeLogo?: string
}

export default function FooterLogo({ 
  siteName, 
  siteLogo, 
  darkModeLogo 
}: FooterLogoProps) {
  const { theme } = useTheme()
  
  // Use dark mode logo if we're in dark mode and a dark mode logo is provided
  const logoSrc = theme === 'dark' && darkModeLogo ? darkModeLogo : siteLogo
  
  return (
    <Image 
      src={logoSrc} 
      alt={siteName} 
      width={160}
      height={60}
      className="w-40 h-15 object-contain" 
      priority
    />
  )
} 